/* global SunergoPlatform */

const logonJs = function() {
	SunergoPlatform.actionButtons.addAction(function(action, button, e) {
		if (action != 'forgot-password-link') return false;
		e.preventDefault();

		const emailField = document.getElementById('logon_username');
		if (!emailField) return false;

		const email = emailField.value;
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
			location.href = `${button.href}?email=${email}`;
		else location.href = button.href;

		return true;
	});
};

SunergoPlatform.onLoad.push(logonJs);